import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/BLPConfiguration";

export const getTypeList = async () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res;
  });
};

export const addType = async (newType) => {
  const { data } = await axios.post(`${api_base_url}`, newType);
  return data;
};

export const deleteType = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}`, {
    data: ids,
  });
  return data;
};

export const updateType = async (editType) => {
  const { data } = await axios.put(`${api_base_url}`, editType);
  return data;
};
